import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Empty, Modal, Tooltip } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState, useMemo } from "react";

//STYLES
import { ContainerInsumo } from "./style";

//APP
import { colorInsumos, widthInsumos } from "./meta";
import { leadZero, transition_default } from "../../../../../../utils";
import { detalhesInsumos, InsumosSaida } from "../../meta/obter_dados";
import { Item__Atividades, Item__UnidadeMedida, ItemPropriedades } from "../../../../../../services/atividades/GET";

//COMPONENTS
import { ModalDetalhesInsumos } from "./modalDetalhes";
import { Item__EquipeCliente } from "../../../../../../services/Equipe/GET";

//PROPS
interface Props {
    dados_insumos_executadas: InsumosSaida[];
    dados_insumos_planejada: InsumosSaida[];
    data_atividades: Item__Atividades[];
    data_unidades_medida: Item__UnidadeMedida[];
    data_propriedades: ItemPropriedades[];
    data_equipe_cliente: Item__EquipeCliente[]
}

export const Insumos: React.FC<Props> = ({ dados_insumos_executadas, dados_insumos_planejada, data_atividades, data_unidades_medida,
    data_propriedades, data_equipe_cliente }) => {

    //REFs
    const refPopup = useRef(null);
    const refPopupTipo = useRef(null);

    //STATES
    const [open_unidade, setOpen_unidade] = useState<boolean>(false);
    const [unidade_selecionada, setUnidade_selecionada] = useState<string>('Por peso');
    const [open_tipo, setOpen_tipo] = useState<boolean>(false);
    const [tipo_selecionada, setTipo_selecionada] = useState<string>('Planejados');
    // const [tipo_selecionada, setTipo_selecionada] = useState<string>('Executados');
    const [equalize_bar, setEqualize_bar] = useState<boolean>(false);
    const [title_modal, setTitle_modal] = useState<string>('');
    const [cod_insumo_selecionado, setCod_insumo_selecionado] = useState<number>(null);
    const [dados_insumo, setDados_insumo] = useState(null);
    const [open_modal, setOpen_modal] = useState<boolean>(false);

    const handleClickOutside: any = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (refPopup.current && !refPopup.current.contains(event.target)) {
            setOpen_unidade(false);
        }
        if (refPopupTipo.current && !refPopupTipo.current.contains(event.target)) {
            setOpen_tipo(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true)
        return () => {
            document.removeEventListener('click', handleClickOutside, true)
        }
    })

    const memoDetalhesInsumos = useMemo(() => {
        return detalhesInsumos(data_atividades, cod_insumo_selecionado, tipo_selecionada, data_propriedades, data_unidades_medida, dados_insumo)
    }, [data_atividades, data_unidades_medida, cod_insumo_selecionado, tipo_selecionada, data_propriedades, dados_insumo]);

    function listaDadosInsumos() {
        return (tipo_selecionada === 'Executados' ? dados_insumos_executadas ?? [] : dados_insumos_planejada ?? [])
    }

    return (
        <ContainerInsumo
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...transition_default, delay: 0.5 }}
            onMouseOver={() => setEqualize_bar(true)}
            onMouseLeave={() => setEqualize_bar(false)}
        >
            <p className="ContainerInsumo__title">Insumos</p>

            <motion.button className="ContainerInsumo__unidade" style={{ right: 120 }} whileTap={{ scale: 0.98 }} onClick={() => setOpen_tipo(true)}>
                {tipo_selecionada}
                <FontAwesomeIcon icon={faAngleDown} />
            </motion.button>

            <motion.button className="ContainerInsumo__unidade" whileTap={{ scale: 0.98 }} onClick={() => setOpen_unidade(true)}>
                {String(unidade_selecionada)?.replace('Por peso', 'Sólidos')?.replace('Por volume', 'Líquidos')?.replace('Por sementes', 'Sementes')}
                <FontAwesomeIcon icon={faAngleDown} />
            </motion.button>

            <AnimatePresence>
                {open_tipo && (
                    <motion.div
                        ref={refPopupTipo}
                        className="ContainerInsumo__opt_unidade"
                        style={{ right: 60 }}
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0, y: -20 }}
                    >
                        <motion.button className="ContainerInsumo__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setTipo_selecionada('Executados'); setOpen_tipo(false) }}>
                            Executados
                        </motion.button>
                        <motion.button className="ContainerInsumo__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setTipo_selecionada('Planejados'); setOpen_tipo(false) }}>
                            Planejados
                        </motion.button>
                    </motion.div>
                )}
            </AnimatePresence>
            <AnimatePresence>
                {open_unidade && (
                    <motion.div
                        ref={refPopup}
                        className="ContainerInsumo__opt_unidade"
                        initial={{ opacity: 0, scale: 0 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0, x: 50, y: -20 }}
                    >
                        <motion.button className="ContainerInsumo__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setUnidade_selecionada('Por peso'); setOpen_unidade(false) }}>
                            Sólidos
                        </motion.button>
                        <motion.button className="ContainerInsumo__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setUnidade_selecionada('Por volume'); setOpen_unidade(false) }}>
                            Líquidos
                        </motion.button>
                        <motion.button className="ContainerInsumo__opt_unidade__item" whileTap={{ scale: 0.98 }} onClick={() => { setUnidade_selecionada('Por sementes'); setOpen_unidade(false) }}>
                            Sementes
                        </motion.button>
                    </motion.div>
                )}
            </AnimatePresence>

            <div className="ContainerInsumo__list">
                {listaDadosInsumos().filter(i => i.filtro === unidade_selecionada || unidade_selecionada === '').map(({ soma_dosagem, lista_insumos, medida_convertida, nome_insumo, nome_medida, quantidade_convertida, quantidade_total, cod_insumo, cod_tipo, calculo_dosagem }, index) => {
                    return (
                        <Tooltip
                            key={nome_insumo + index}
                            destroyTooltipOnHide
                            autoAdjustOverflow
                            placement="left"
                            title={`${leadZero(index + 1)}°`}
                        >
                            <motion.button
                                className="ContainerInsumo__list__item"
                                initial={{ width: 0 }}
                                animate={{ width: equalize_bar ? '100%' : widthInsumos(quantidade_total) }}
                                transition={{ ...transition_default, delay: 0 }}
                                whileTap={{ scale: 0.95 }}
                                onClick={() => {
                                    setTitle_modal(nome_insumo);
                                    setDados_insumo({ quantidade_total, quantidade_convertida, medida_convertida, lista_insumos });
                                    setOpen_modal(true);
                                    setCod_insumo_selecionado(cod_insumo);
                                }}
                                style={{
                                    background: colorInsumos(quantidade_total).bg,
                                    minWidth: 220
                                }}>

                                <span className="ContainerInsumo__list__item__name" style={{ color: colorInsumos(quantidade_total).color }}>{String(nome_insumo).toLowerCase()}</span>

                                <div style={{ display: 'flex', gap: 4 }}>
                                    {cod_tipo === 8 && (
                                        <span className="ContainerInsumo__list__item__size_incoculante">
                                            {calculo_dosagem}
                                        </span>
                                    )}
                                    <span className="ContainerInsumo__list__item__size">
                                        {(quantidade_convertida)} {medida_convertida}
                                    </span>
                                </div>
                            </motion.button>
                        </Tooltip>
                    )
                })}

                {(tipo_selecionada === 'Executados' ? dados_insumos_executadas ?? [] : dados_insumos_planejada ?? []).length === 0 && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>Nenhum insumo de atividade <b>{tipo_selecionada}</b>  <b>{unidade_selecionada}</b>  de encontrado</>} />
                )}
                {(tipo_selecionada === 'Executados' ? dados_insumos_executadas ?? [] : dados_insumos_planejada ?? []).length > 0 && (tipo_selecionada === 'Executados' ? dados_insumos_executadas ?? [] : dados_insumos_planejada ?? []).filter(i => i.filtro === unidade_selecionada || unidade_selecionada === '').length === 0 && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>Nenhum insumo de atividade <b>{tipo_selecionada}</b>  <b>{unidade_selecionada}</b>  de encontrado</>} />
                )}
            </div>

            <Modal
                open={open_modal}
                onCancel={() => setOpen_modal(false)}
                footer={false}
                title={title_modal ?? 'Detalhes do insumo'}
                width={1000}
                destroyOnClose
            >
                <ModalDetalhesInsumos
                    nome_insumo={title_modal}
                    medida_normalizada={dados_insumo?.medida_convertida}
                    quantidade_convertida={dados_insumo?.quantidade_convertida}
                    quantidade_normalizada={dados_insumo?.quantidade_normalizada}
                    list_talhoes_insumos={memoDetalhesInsumos}
                    data_unidades_medida={data_unidades_medida}
                    tipo_selecionada={tipo_selecionada}
                    data_equipe_cliente={data_equipe_cliente}
                />
            </Modal>

        </ContainerInsumo>
    )
};